const CONNECTIONS_ROUTE_CACHE_KEY = "asasiasaConnectionsRouteSnapshot";
const CONNECTIONS_ROUTE_CACHE_MAX_AGE = 2 * 60 * 1000;

const normalizeSnapshot = (snapshot = {}) => ({
  accepted: Array.isArray(snapshot.accepted) ? snapshot.accepted : [],
  incoming: Array.isArray(snapshot.incoming) ? snapshot.incoming : [],
  sent: Array.isArray(snapshot.sent) ? snapshot.sent : [],
  messages: Array.isArray(snapshot.messages) ? snapshot.messages : [],
});

export const writeConnectionsRouteCache = (snapshot) => {
  try {
    sessionStorage.setItem(
      CONNECTIONS_ROUTE_CACHE_KEY,
      JSON.stringify({
        cachedAt: Date.now(),
        snapshot: normalizeSnapshot(snapshot),
      }),
    );
  } catch {
    // Cache is only a navigation optimization.
  }
};

export const readConnectionsRouteCache = () => {
  try {
    const raw = sessionStorage.getItem(CONNECTIONS_ROUTE_CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (
      !parsed?.cachedAt ||
      Date.now() - parsed.cachedAt > CONNECTIONS_ROUTE_CACHE_MAX_AGE
    ) {
      sessionStorage.removeItem(CONNECTIONS_ROUTE_CACHE_KEY);
      return null;
    }

    return normalizeSnapshot(parsed.snapshot);
  } catch {
    return null;
  }
};
